import gql from 'graphql-tag';

// important that the usage define whether they want the enabled items or not (true, false, null)
export function getPolicySetCoreAttributes(enabled) {
  return `
    id
    name
    description
    isAvailable
    isImported
    items(enabled: ${enabled}) {
      id
      reason
      customCheck {
        id
        name
        notes
        category
        categoryOverwritten
        categoryOriginal
        rules {
          id
          type
          rule
          onlyCheckText
          ignoreCase
          contains
          urlOption
          includePartialMatches
        }
      }
    }
    tags {
      id
      name
    }
  `;
}

export const PolicSetQuery = gql`
  query PolicySet($accountId: String!, $policySetId: String!) {
    policySet(accountId: $accountId, policySetId: $policySetId) {
      ${getPolicySetCoreAttributes(true)}
    }
  }
`;

export const PolicySetsQuery = gql`
  query PolicySets($accountId: String!, $search: String, $tagId: String, $page: Int!, $perPage: Int!, $sortBy: PolicySetsSortBy!, $sortOrder: SortOrder!) {
    policySets(accountId: $accountId, search: $search, tagId: $tagId, page: $page, perPage: $perPage, sortBy: $sortBy, sortOrder: $sortOrder) {
      nodes {
        ${getPolicySetCoreAttributes(true)}
      }
      currentPage
      perPage
      totalEntries
      totalPages
    }
  }
`;

export const PolicySetTagsQuery = gql`
  query PolicySetTags($accountId: String!, $search: String, $page: Int!, $perPage: Int!, $sortBy: PolicySetTagsSortBy!, $sortOrder: SortOrder!) {
    policySetTags(accountId: $accountId, search: $search, page: $page, perPage: $perPage, sortBy: $sortBy, sortOrder: $sortOrder) {
      nodes {
        id
        name
        description
      }
      currentPage
      perPage
      totalEntries
      totalPages
    }
  }
`;

export const UpdatePolicySetMutation = gql`
  mutation UpdatePolicySet($accountId: String!, $policySetId: String!, $isImported: Boolean, $category: CustomCheckCategory) {
    updatePolicySet(accountId: $accountId, policySetId: $policySetId, isImported: $isImported, category: $category) {
      policySet {
        ${getPolicySetCoreAttributes(true)}
      }
      account {
        id
        name
        errorMessages
      }
    }
  }
`;

export const policySetItemStateDefaults = {
  customCheckId: null,
  reason: '',
};

export const policySetStateDefaults = {
  name: '',
  description: '',
  isAvailable: false,
  items: [{ ...policySetItemStateDefaults }],
  tags: [],
  accounts: [],
};

